import { Input, Modal } from "antd";
import React from "react";
import { Userpilot } from "userpilot";

type CustomPromptModalProps = {
  customModalVisible: boolean;
  customPrompt: string;
  setCustomPrompt: (prompt: string) => void;
  setCustomModalVisible: (visible: boolean) => void;
  refineMode: boolean;
  handleAutoGenerate: (
    useLibraryData: boolean,
    refineMode: boolean,
    customPrompt: string | null
  ) => void;
};

export const CustomPromptModal = ({
  customModalVisible,
  customPrompt,
  setCustomPrompt,
  setCustomModalVisible,
  refineMode,
  handleAutoGenerate,
}: CustomPromptModalProps) => {
  return (
    <Modal
      okButtonProps={{ disabled: !customPrompt }}
      title="Custom Prompt"
      open={customModalVisible}
      onOk={() => {
        Userpilot.track(refineMode ? "ai_refine_scope" : "ai_first_draft_custom");
        handleAutoGenerate(true, refineMode && !!customPrompt, customPrompt ? customPrompt : null);
        setCustomModalVisible(false);
      }}
      onCancel={() => {
        setCustomModalVisible(false);
      }}
    >
      <p>
        Use this prompt to customise the scope. You can make suggestions for style and tone, or
        provide extra information about the matter to get more tailored results.
      </p>
      <Input.TextArea
        required
        rows={4}
        value={customPrompt}
        onChange={(e) => setCustomPrompt(e.target.value)}
        placeholder="Enter custom prompt/instructions here..."
      />
    </Modal>
  );
};
